
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Fallopian_tube_neoplasms",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Fallopian_tube_neoplasms.vue